import { FilterContentFieldDataTypes, IFilter } from '@hevoio/hevo-ui-toolkit';
import { IWorkspace } from '../interfaces/workspace';

export function getWorkspaceFilters(workspaces: IWorkspace[]): IFilter[] {
  return [
    {
      title: 'Workspace',
      filterKey: 'name',
      filterType: FilterContentFieldDataTypes.LIST,
      filterContentProps: {
        multiple: true,
        options: workspaces.map(w => ({ label: w.name, value: w.name })),
        textFieldProps: {
          prefixIcon: 'search',
          placeholder: 'Search Workspace'
        }
      }
    },
    {
      title: 'Status',
      filterKey: 'status',
      filterType: FilterContentFieldDataTypes.LIST,
      filterContentProps: {
        multiple: true,
        selectMode: true,
        options: [
          { label: 'Active', value: 'Active' },
          { label: 'Deleted', value: 'Deleted' },
          { label: 'Setup Incomplete', value: 'SetupIncomplete' }
        ]
      }
    }
  ];
}
